import type { BloodTestPackage } from "../models/blood-test-package";
import type { CartProduct } from "../models/cart-product";

export function purchaseCatalogRowKey(v: Pick<BloodTestPackage, "uuid"> & { listItemId?: number }): string {
  return v.listItemId != null ? `li:${v.listItemId}` : v.uuid;
}

export function isSamePurchaseCatalogLine(
  cart: Pick<CartProduct, "uuid"> & { listItemId?: number },
  row: Pick<BloodTestPackage, "uuid"> & { listItemId?: number },
): boolean {
  if (row.listItemId != null || cart.listItemId != null) {
    return row.listItemId != null && cart.listItemId != null && cart.listItemId === row.listItemId;
  }
  return cart.uuid === row.uuid;
}
